<template>
  <div class="price">
    <span class="price__number" v-html="formattedPrice" />
    <span class="price__currency">{{ currencyName }}</span
    ><slot></slot>
  </div>
</template>

<script>
import { formatNumber } from '~scripts/core/helpers';
import priceData from './price-data.json';

export default {
  name: 'VPrice',
  props: {
    tariff: {
      String,
      required: true,
    },
    period: {
      String,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
  },
  computed: {
    formattedPrice() {
      const { tariff, period, currency } = this;
      const price = priceData.tariffs[tariff][period][currency];
      return formatNumber(price);
    },
    currencyName() {
      const { currency } = this;
      return priceData.currencies[currency];
    },
  },
};
</script>
